import {
  PULSE_CLICK_ACTION,
  PULSE_CLICK_CATEGORY,
  trackPulseClick,
} from './pulseClickIds';
import { PULSE_VIEW_ID } from './pulseViewIds';

/** Profile → Delivery Addresses — remove address CTA. */
export const trackDeleteDeliveryAddressClick = ({
  address_id,
  label = null,
  page_path,
}: {
  address_id: string | number;
  label?: string | null;
  page_path?: string;
}): void => {
  trackPulseClick({
    category: PULSE_CLICK_CATEGORY.CUSTOMER_PAGE,
    action: PULSE_CLICK_ACTION.TAP_DELETE_DELIVERY_ADDRESS,
    label,
    view_id: PULSE_VIEW_ID.PROFILE_DELIVERY_ADDRESSES,
    page_id: PULSE_CLICK_CATEGORY.CUSTOMER_PAGE,
    page_path,
    additional_params: { address_id },
  });
};

/** Profile → Delivery Addresses — change default address (radio select). */
export const trackChangeDefaultDeliveryAddressClick = ({
  address_id,
  label = null,
  page_path,
}: {
  address_id: string | number;
  label?: string | null;
  page_path?: string;
}): void => {
  trackPulseClick({
    category: PULSE_CLICK_CATEGORY.CUSTOMER_PAGE,
    action: PULSE_CLICK_ACTION.TAP_CHANGE_DEFAULT_DELIVERY_ADDRESS,
    label,
    view_id: PULSE_VIEW_ID.PROFILE_DELIVERY_ADDRESSES,
    page_id: PULSE_CLICK_CATEGORY.CUSTOMER_PAGE,
    page_path,
    additional_params: { address_id },
  });
};
